module.exports = __webpack_public_path__ + "static/media/login.4f84cace.png";